<template>
  <van-popup
    v-model="showPersonPopup"
    round
    position="bottom"
    :style="{ height: '400px' }"
  >
    <div class="add-person">
      <div class="add-person-title">
        添加同行人员
      </div>
      <van-field name="uploader" required label="识别头像" size="large" center>
        <template #input>
          <van-uploader
            :after-read="afterReadPerson"
            :before-delete="beforeDelPerson"
            v-model="addPersonFileList"
            :max-count="1"
            multiple
          >
            <img
              src="../../assets/images/avatar.png"
              alt=""
              style="width: 2.75rem; height: 2.75rem; object-fit: cover;"
            />
          </van-uploader>
        </template>
      </van-field>
      <van-field
        v-model="paramsList.visitorName"
        label="姓名"
        placeholder="请输入姓名"
        size="large"
        required
      />
      <van-field
        v-model="paramsList.visitorPhone"
        label="手机号"
        placeholder="请输入手机号"
        size="large"
        required
      />
      <van-field
        v-model="paramsList.visitorIdCrde"
        label="身份证号"
        placeholder="请输入身份证号"
        size="large"
      />

      <van-row class="add-btn-group" gutter="20">
        <van-col span="12" style="text-align: right;">
          <van-button type="default" block @click="showPersonPopup = false">
            取消</van-button
          >
        </van-col>
        <van-col span="12">
          <van-button type="info" block @click="handleAddPerson"
            >确认</van-button
          >
        </van-col>
      </van-row>
    </div>
  </van-popup>
</template>

<script>
import { upload } from '@/utils/upload'

const paramsList = {
  visitorName: '',
  visitorPhone: '',
  visitorIdCrde: '',
  photoImg: '',
}
export default {
  data() {
    return {
      showPersonPopup: false,
      paramsList: Object.assign(paramsList),
      addPersonFileList: [],
    }
  },
  methods: {
    handleAddPerson() {
      if (!this.viladateForm()) {
        return false
      }

      this.$emit('changeItem', this.paramsList)
      this.addPersonFileList = []
      this.paramsList = {}
      this.showPersonPopup = false
    },
    viladateForm() {
      if (!this.paramsList.photoImg) {
        this.$toast('请上传头像')
        return false
      }
      if (!this.paramsList.visitorName) {
        this.$toast('请输入姓名')
        return false
      }

      if (!this.paramsList.visitorPhone) {
        this.$toast('请输入手机号')
        return false
      }
      return true
    },
    async afterReadPerson(file) {
      const imgUrl = await upload(file.file)
      this.paramsList.photoImg = imgUrl
    },
    beforeDelPerson(item, obj) {
      this.addPersonFileList.splice(obj.index, 1)
      this.paramsList.photoImg = ''
    },
  },
}
</script>

<style lang="scss" scoped>
.add-person {
  padding: 15px 20px;
  .add-person-title {
    text-align: center;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .add-btn-group {
    margin-top: 20px;
  }
}
</style>
